if(!customElements.get('custom-tabs')){
    class CustomTabs extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            // set tab navigation menu
            this.tabColumns = this.querySelectorAll('.tabs__pane-inner');
            this.tabNavigation = this.querySelector('.tabs__navigate-tabs .swiper-wrapper');
            this.tabColumns.forEach((column, index) => {
                const blockId = column.dataset.blockId;
                const tabName = column.dataset.tabName;

                // Create tab navigation item
                const tabItem = document.createElement('div');
                tabItem.classList.add('swiper-slide');
                const tabLink = document.createElement('a');
                tabLink.href = '#';

                const textType = this.dataset.navigationTextType || 'p';
                tabLink.classList.add(
                    'tabs__navigate-tab',
                    'duration-300',
                    'ease-in-out',
                    'transition-all',
                    'cursor-pointer',
                    'flex',
                    'items-center',
                    'justify-center',
                    textType
                );
                
                tabLink.setAttribute('data-block-id', blockId);

                tabLink.dataset.active = index === 0 ? 'true' : 'false';
                tabLink.innerText = tabName;

                tabItem.appendChild(tabLink);
                this.tabNavigation.appendChild(tabItem);
            });

            this.tabPanes = this.querySelectorAll('.tabs__pane');
            this.tabPanes.forEach((pane, index) => {
                pane.setAttribute('data-active', index === 0 ? 'true' : 'false');
                if(index === 0){
                    pane.removeAttribute('inert');
                }else{
                    pane.setAttribute('inert', '');
                }
            });

            this.initializeSwiper();

            this.tabs = this.querySelectorAll('.tabs__navigate-tab');
            this.tabs.forEach(tab => {
                tab.addEventListener('click', this.handleTabClick.bind(this));
                tab.addEventListener('keydown', (e) => {
                    if(e.key === 'Enter' || e.key === ' '){
                        this.handleTabClick(e);
                    }
                });
            });

            // check if tab navigation bar should be sticky
            this.tabNavigationWrapper = this.querySelector('.tabs__navigate-tabs');
            this.onTabNavigationBarInView();
            window.addEventListener("scroll", this.onTabNavigationBarInView.bind(this));
            window.addEventListener("resize", this.onTabNavigationBarInView.bind(this));
        }

        onTabNavigationBarInView(){
            if(!this.tabNavigationWrapper) return;
            if(this.tabNavigationWrapper.dataset.sticky !== 'true') return;

            let tabNavigationStaticY = this.tabNavigationWrapper.getBoundingClientRect().top;
            const header = document.querySelector('custom-header');
            if(header){
                if(header.dataset.scroll === 'true'){
                    tabNavigationStaticY = tabNavigationStaticY + header.offsetHeight;
                }
            }

            const tabNavigationWrapperScrolled = this.querySelector('.tabs-navigate-tabs--scrolled') || this.tabNavigationWrapper.cloneNode(true);
            if(!tabNavigationWrapperScrolled.classList.contains('tabs-navigate-tabs--scrolled')){
                tabNavigationWrapperScrolled.classList.add('tabs-navigate-tabs--scrolled');
            }
           
            if(tabNavigationStaticY > 0){
                tabNavigationWrapperScrolled.classList.remove('active');
            }else{
                tabNavigationWrapperScrolled.classList.add('active');
            }

            if(!this.querySelector('.tabs-navigate-tabs--scrolled')){
                this.appendChild(tabNavigationWrapperScrolled);

                // add event listner
                this.scrolledTabs = this.querySelectorAll('.tabs-navigate-tabs--scrolled .tabs__navigate-tab');
                this.scrolledTabs.forEach(tab => {
                    tab.addEventListener('click', this.handleTabClick.bind(this));
                    tab.addEventListener('keydown', (e) => {
                        if(e.key === 'Enter' || e.key === ' '){
                            this.handleTabClick(e);
                        }
                    });
                });

                // initialize swiper on the cloned scrolled tab bar
                this.initializeSwiperOn(tabNavigationWrapperScrolled.querySelector('.swiper-container'));
            }
        }

        handleTabClick(e){
            e.preventDefault();

            const target = e.currentTarget;
            if(!target) return;

            const targetId = e.currentTarget.dataset.blockId;
            if(!targetId) return;

            const tabs = this.querySelectorAll('.tabs__navigate-tab');
            tabs.forEach(tab => {
                tab.setAttribute('data-active', tab.dataset.blockId === targetId? 'true' : 'false');
            });

            const targetPaneInner = this.querySelector(`.tabs__pane-inner[data-block-id="${targetId}"]`);
            const targetPane = targetPaneInner?.closest('.tabs__pane');
            if(!targetPane) return;

            this.tabPanes.forEach(pane => {
                if(pane === targetPane){
                    pane.setAttribute('data-active', 'true');
                    pane.removeAttribute('inert');
                }else{
                    pane.setAttribute('data-active', 'false');
                    pane.setAttribute('inert', '');
                }
            });

            // scroll back to top of the section
            window.scrollTo({
                top: this.offsetTop,
                behavior: 'smooth'
            });

            this.stopVideos();
            this.playVideos();
        }

        playVideos(){
            const videos = this.querySelectorAll('.tabs__pane[data-active="true"] video');
            videos.forEach(video => {
                if(typeof video === 'undefined') return;
                video.addEventListener("loadeddata", e => {
                    video.classList.add('loaded');
                    video.play();
                });

                if(video.readyState >= 2){
                    video.classList.add('loaded');
                    video.play();
                }
            });
        }

        stopVideos(){
            const videos = this.querySelectorAll('.tabs__pane[data-active="false"] video');
            videos.forEach(video => {
                video.pause();
                this.resetVideo(video);
            });
        }

        resetVideo(video){
            if(video.readyState > 0){
                video.currentTime = 0;
            }else{
                video.addEventListener(
                    "loadedmetadata",
                    function onMeta() {
                        video.currentTime = 0;
                        video.removeEventListener("loadedmetadata", onMeta);
                    },
                    { once: true });
            }
        }

        async initializeSwiper(){
            this.swiperContainer = this.querySelector('.swiper-container');
            if(!this.swiperContainer) return;

            this.swiper = await this.initializeSwiperOn(this.swiperContainer);
            this.setupFocusListeners();
        }

        async initializeSwiperOn(container){
            if(!container) return null;

            const slides = container.querySelectorAll(".swiper-slide");
            if(slides.length <= 1) return null;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            const itemsPerView = parseInt(container.dataset.itemsPerView);
            const itemsPerViewMobile = parseInt(container.dataset.itemsPerViewMobile);
            const totalSlides = container.dataset.itemsTotal;
            const autoplay = container.dataset.autoplay === 'true';
            const speed = parseInt(container.dataset.speed);
            const loop = container.dataset.loop === 'true';
            const visibleItemsPerView = (itemsPerView && totalSlides > itemsPerView)? itemsPerView : totalSlides;
            const spaceBetween = parseInt(container.dataset.gap);

            const breakpoints = {
                0: { slidesPerView: itemsPerViewMobile },
                768: { slidesPerView: visibleItemsPerView }
            }

            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: breakpoints,
                observer: true,
                observeSlideChildren: true,
                watchSlidesProgress: true,
                autoHeight: false,
                spaceBetween: spaceBetween
            }

            if(container.querySelector(".swiper-navigation-wrapper")){
                swiperSettings.navigation = {
                    nextEl: container.querySelector('.button-next'),
                    prevEl: container.querySelector('.button-previous')
                }
            }

            if(autoplay && !isNaN(speed)){
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            const swiper = new Swiper(container, swiperSettings);
            swiper.init();

            return swiper;
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next, .button-previous").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }
    }

    customElements.define('custom-tabs', CustomTabs);
}